const FLIGHTSSAMEROUTE_UPDATED = (state, FlightsSameRoute) => {
  state.FlightsSameRoute = FlightsSameRoute
}

export default {
  FLIGHTSSAMEROUTE_UPDATED
}
